export default __webpack_public_path__ + "static/media/image3.21bc3fd8.png";